import {Component, HostListener, OnInit} from '@angular/core';
import {IconComponent} from '../../../elements/icon/icon.component';
import {Icons} from '../../../../model/icon';
import {Location, NgIf} from '@angular/common';
import {Router} from '@angular/router';
import {scrollUp} from '../../../../functions/scroll-up';
import {MenuService} from '../../../../services/menu-services';

@Component({
  selector: 'app-new-mobile-header',
  imports: [
    IconComponent,
    NgIf
  ],
  templateUrl: './new-mobile-header.component.html',
  styleUrl: './new-mobile-header.component.scss'
})
export class NewMobileHeaderComponent implements OnInit {
  constructor(public location: Location,
              private router: Router,
              protected menuService: MenuService) {}

  isMobile: boolean = false;

  @HostListener('document:focusin', ['$event'])
  onFocusIn(event: FocusEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
      this.menuService.setInputFocused(true);
    }
  }

  @HostListener('document:focusout', ['$event'])
  onFocusOut(event: FocusEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
      setTimeout(() => {
        const activeElement = document.activeElement as HTMLElement;
        if (activeElement?.tagName !== 'INPUT' && activeElement?.tagName !== 'TEXTAREA') {
          this.menuService.setInputFocused(false);
        }
      }, 100);
    }
  }

  ngOnInit() {
    if (window.innerWidth < 571) {
      this.isMobile = true;
    }
  }

  onClick(type: 'destinations' | 'meal' | 'feedback' | 'menu') {
    switch (type) {
      case 'destinations': {
        scrollUp();
        this.menuService.setMobileActive(false);
        this.router.navigate([ '/destinations' ]).then(r => r);
        break;
      }
      case 'meal': {
        scrollUp();
        this.menuService.setMobileActive(false);
        this.router.navigate([ '/services' ]).then(r => r);
        break;
      }
      case 'feedback': {
        scrollUp();
        this.menuService.setMobileActive(false);
        this.router.navigate([ '/feedback' ]).then(r => r);
        break;
      }
      case 'menu': {
        this.menuService.setMobileActive(!this.menuService.getMobileActive());
        if (this.menuService.getMobileStyle() === 'transparent') {
          this.menuService.setMobileStyle('white');
        }
        break
      }
    }
  }

  get styleDisplay() {
    if (!this.isMobile) {
      return 'none'
    }
    return this.menuService.getInputFocused() ? 'none' : 'flex';
  }

  get invert() {
    return this.menuService.getMobileStyle() === 'white';
  }

  get headerStyle() {
    if (this.menuService.getMobileStyle() === 'white') {
      return `background: var(--background-color)`
    }
    if (this.menuService.getMobileStyle() === 'black') {
      return `background: black`
    }
    return '';
  }

  getClassActive(type: 'destinations' | 'services' | 'feedback') {
    if (this.menuService.getMobileActive()) {
      return false;
    }
    switch (type) {
      case 'destinations': {
        return this.location.path() === '/destinations'
      }
      case 'services': {
        return this.location.path() === '/services'
      }
      case 'feedback': {
        return this.location.path() === '/feedback'
      }
    }
  }

  protected readonly Icons = Icons;
}
